import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
export var Range = /*#__PURE__*/_createClass(function Range(x, y) {
  _classCallCheck(this, Range);

  this.position = {
    x: x,
    y: y
  };
});